<template>
  <div v-if="showStatsMenu">
    <v-app-bar app flat color="black">
      <v-container max-width="1200" class="mx-auto py-1">
        <div class="title-section">
          <img :src="season?.imageUrl
            ? `/uploads/leagues/h200-${season.imageUrl}`
            : `/uploads/leagues/default.png`" alt="Hlavní obrázek" height="40px" />
          <span class="title-text mr-2 ">
            {{ season?.title }} {{ season?.year ? season.year : '' }}
          </span>

          <v-tabs v-model="activeSection" class="px-0 d-none d-sm-flex">
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/schedule`" key="schedule" class="my-tab"
              :text="$t('schedule')"></v-tab>
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/standings`" key="standings" class="my-tab"
              :text="$t('standings')"></v-tab>
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/statistics`" key="stats" class="my-tab"
              :text="$t('stats')"></v-tab>
            <v-tab disabled :to="`/leagues/${season.urlTitle}/${season.year}/info`" key="stats" class="my-tab"
              :text="$t('info')"></v-tab>
            <v-tab disabled :to="`/leagues/${season.urlTitle}/${season.year}/seasons`" key="stats" class="my-tab"
              :text="$t('seasons')"></v-tab>

          </v-tabs>
        </div>
      </v-container>

      <v-app-bar-nav-icon @click="drawer = !drawer" class="d-sm-none "></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app temporary color="black" location="end">
      <v-list>

        <v-list-item :to="`/leagues/${season.urlTitle}/${season.year}/schedule`">
          <v-list-item-title>
            {{ $t('schedule') }}
          </v-list-item-title>
        </v-list-item>

         <v-divider></v-divider>

         <v-list-item :to="`/leagues/${season.urlTitle}/${season.year}/standings`">
          <v-list-item-title>
            {{ $t('standings') }}
          </v-list-item-title>
        </v-list-item>

         <v-divider></v-divider>

        <v-list-item :to="`/leagues/${season.urlTitle}/${season.year}/statistics`">
          <v-list-item-title>
            {{ $t('stats') }}
          </v-list-item-title>
        </v-list-item>

         <v-divider></v-divider>

        <v-list-item :to="`/leagues/${season.urlTitle}/${season.year}/info`">
          <v-list-item-title>
            {{ $t('info') }}
          </v-list-item-title>
        </v-list-item>

         <v-divider></v-divider>

        <v-list-item :to="`/leagues/${season.urlTitle}/${season.year}/seasons`">
          <v-list-item-title>
            {{ $t('seasons') }}
          </v-list-item-title>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps } from 'vue';

import { useRoute } from 'vue-router';
import { useDisplay } from 'vuetify';


const { smAndDown, mdAndUp } = useDisplay();
const route = useRoute();

defineProps({
  season: {
    type: Object,
    required: true,
    default: () => ({
      title: 'hockeybook.online',
      urlTitle: null,
      year: null,
      imageUrl: null,
    }),
  },
});

// Stav pro boční menu (drawer)
const drawer = ref(false);


const showStatsMenu = computed(() => route.path.includes('/leagues/') || route.path.includes('/match/'));

const activeSection = ref(0);


const isMobile = computed(() => smAndDown.value);
const isDesktop = computed(() => mdAndUp.value);

</script>

<style scoped>
.v-tab.my-tab {
  height: 30px !important;
}

.title-section {
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  text-align: center;
  padding: 3px 0;
  font-size: 0.9rem;
}

.title-text {
  font-family: 'Aileron', sans-serif;
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
